import { z } from 'zod';

export const PlatformSchema = z.enum(['web', 'mobile']);

export type Platform = z.infer<typeof PlatformSchema>;
